// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__VNn5c","footer":"Wrapper_footer__-p7Qo"};